import React from "react";
import { useForm } from "react-hook-form";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import MachineViewDialog from "../dialog/MachineViewDialog";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import { CirclePlus } from "lucide-react";

const AddMachineForm = ({
  machineSetup,
  sendData,
  loading,
  successResponse,
}) => {
  const {
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    sendData(data, reset);
  };
  return (
    <>
      <div className="form-container">
        <CenteredHeading title="Add Machine" />
        <form
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="flex flex-wrap">
            <div className="leftCol mx-auto pr-0">
              <SearchDropdown
                name="categoryId"
                label="Category *"
                keyName="name"
                id="id"
                options={machineSetup.categories}
                control={control}
                setValue={setValue}
                selectedVal={watch("categoryId")}
                error={errors.categoryId}
              />
            </div>
          </div>
          <div className="addBtn---wrap gap-2">
            <PrimaryButton
              btnText={!loading ? "Add Machine" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </div>
        </form>
      </div>
      {successResponse && (
        <MachineViewDialog viewDetails={successResponse} successView={true} />
      )}
    </>
  );
};
export default AddMachineForm;
